import type {
  BlocksDownloadComponent,
  LinksLinkListComponent,
} from '@twisto/api-cms/generated-types'

import { Hidden } from 'homepage/components/atoms/hidden'
import {
  LinkList,
  SecondaryDowndloadWidget,
} from 'homepage/components/molecules'

import * as styles from './footer.styles'

type Props = {
  groupedColumns: LinksLinkListComponent[][] | undefined
  widget?: BlocksDownloadComponent | undefined
}

export const DesktopGroupedColumns = ({ groupedColumns, widget }: Props) => (
  <Hidden as="div" breakpoint="smDown" css={styles.columns}>
    {groupedColumns?.map((group, groupIndex) => (
      <div key={groupIndex} css={styles.column}>
        {group.map((column) => (
          <LinkList key={column.id} {...column} />
        ))}
      </div>
    ))}
    <SecondaryDowndloadWidget styles={styles.widget} {...widget} />
  </Hidden>
)
